module.exports = __webpack_public_path__ + "static/media/speaker.a4475c16.svg";